import DataDisplayRowI from "../DataDisplayRowI";
import getStoreItemIncompleteRow from "../DataDisplayRow/StoreItemIncompleteRow";
import DataDisplayTable from "../DataDisplayTable";

class StoreItemIncompleteTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getStoreItemIncompleteRow()
    }
}

let storeItemIncompleteTable: StoreItemIncompleteTable | null = null;

export default function getStoreItemIncompleteTable(): StoreItemIncompleteTable {
    if (storeItemIncompleteTable === null)
        storeItemIncompleteTable = new StoreItemIncompleteTable()
    return storeItemIncompleteTable
}